export function calculateDistance(latitud1, longitud1, latitud2, longitud2, unidad) {
    // Radio de la Tierra en kilómetros
    const radioTierra = 6371
    const unit = 'Km'
    // Convertir las coordenadas de grados a radianes
    const latitud1Rad = (latitud1 * Math.PI) / 180
    const longitud1Rad = (longitud1 * Math.PI) / 180
    const latitud2Rad = (latitud2 * Math.PI) / 180
    const longitud2Rad = (longitud2 * Math.PI) / 180

    // Calcular la diferencia de latitud y longitud
    const deltaLatitud = latitud2Rad - latitud1Rad
    const deltaLongitud = longitud2Rad - longitud1Rad

    // Calcular la distancia utilizando la fórmula del haversine
    const a = Math.sin(deltaLatitud / 2) ** 2 + Math.cos(latitud1Rad) * Math.cos(latitud2Rad) * Math.sin(deltaLongitud / 2) ** 2
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    let distancia = radioTierra * c

    // Convertir la distancia a metros si se especifica la unidad como "metros"
    if (unidad === 'metros') {
        distancia *= 1000
    }
    // Convertir la distancia a metros si es menor a 1 km
    if (distancia < 1) {
        distancia *= 1000
        unit = 'mts'
    }
    return distancia.toFixed(2) + unit
}

export function distanceInMeters(lat1, lon1, lat2, lon2) {
    try {
        let rad = function (x) {
            return (x * Math.PI) / 180
        }
        let R = 6378.137 //Radio de la Earth en km
        let dLat = rad(lat2 - lat1)
        let dLong = rad(lon2 - lon1)

        if (dLong != 0 && dLat != 0) {

            let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(lat1)) * Math.cos(rad(lat2)) * Math.sin(dLong / 2) * Math.sin(dLong / 2)
            let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

            //aquí obtienes la distancia en metros por la conversion 1Km =1000m
            var d = R * c * 1000
            return Number.isNaN(d) ? 0 : d
        } else {
            return 0
        }

    } catch (error) {
        console.log(error)
        return 0
    }
}

export function getDistanceWithText(lat1, lon1, lat2, lon2) {
    let sufix = ''
    let distance = distanceInMeters(lat1, lon1, lat2, lon2)
    // console.log('Distancia', distance)
    if (distance < 1000) {
        sufix = ' mts'
    } else {
        distance = distance / 1000
        sufix = ' km'
    }
    return distance.toFixed(2) + sufix
}
export function getDistanceWithTextCal(distance) {
    //console.log("🚀 ~ getDistanceWithTextCal ~ distance:", distance)
    let sufix = ''
    //let distance = distanceInMeters(lat1, lon1, lat2, lon2)
    // console.log('Distancia', distance)
    if (distance && distance < 1000) {
        sufix = ' mts'
    } else {
        distance = distance / 1000
        sufix = ' km'
    }
    return distance != '0' ? distance.toFixed(2) + sufix : '0' + sufix
}
